export default "__VITE_ASSET__Br1CNAi___"